import 'focus-visible';

import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { AppContextProvider } from './contexts/appContext';
import { MeetingContextProvider } from './contexts/meetingContext';
import { OverlayContextProvider } from './contexts/overlayContext';
import { AppConfigContextProvider } from './contexts/appConfigContext';

import App from './app';

import currentPartner, { isEmbeddable } from './constants/partners';
import { ErrorBoundary } from './errorBoundary';
import { ViewContextProvider } from './contexts/viewContext';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import WebPushService from './services/WebPushService';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container not found');
}
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <BrowserRouter basename={currentPartner?.basePath}>
      <AppConfigContextProvider>
        <ViewContextProvider>
          <OverlayContextProvider>
            <AppContextProvider>
              <MeetingContextProvider>
                <App />
              </MeetingContextProvider>
            </AppContextProvider>
          </OverlayContextProvider>
        </ViewContextProvider>
      </AppConfigContextProvider>
    </BrowserRouter>
  </ErrorBoundary>
);
if (WebPushService.hasCapabilities() && !isEmbeddable()) {
  serviceWorkerRegistration.register({
    bypassNodeEnvProduction: true,
  });
}
